/**
 * Wave 5.9 Build 11 (2026-02) — Shared button system for punch/portal.
 *
 * Purpose: one place that defines primary + secondary button styling so
 * the punch list, portal, and thread composer stay visually consistent
 * across light and dark modes.
 *
 * Rules:
 *   - PRIMARY = solid brand-colored fill with white text. Use for
 *     Acknowledge, Mark Complete, Verify, Post, Save.
 *   - SECONDARY = white fill, visible slate border, dark text. Hover
 *     lightens the fill. Use for Comment, Attach, Cancel, Choose existing,
 *     Take photo.
 *   - DANGER = red border, red text on white; used sparingly (Delete, Undo).
 *
 * Everything is designed for min-h-[44px] touch targets on mobile.
 */

// Brand accent color is #70170F (deep maroon) — used throughout the app.
export const PUNCH_BTN_PRIMARY = (
  'inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md ' +
  'bg-[#70170F] hover:bg-[#5a1109] active:bg-[#4a0e07] text-white font-semibold ' +
  'text-sm shadow-sm transition-colors ' +
  'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#70170F]'
);

// Green primary — used only for "Mark complete" (success/finish action).
export const PUNCH_BTN_PRIMARY_SUCCESS = (
  'inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md ' +
  'bg-green-600 hover:bg-green-700 active:bg-green-800 text-white font-semibold ' +
  'text-sm shadow-sm transition-colors ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'
);

export const PUNCH_BTN_SECONDARY = (
  'inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md ' +
  'bg-white hover:bg-slate-50 active:bg-slate-100 text-slate-800 ' +
  'border border-slate-300 text-sm font-medium transition-colors ' +
  'dark:bg-[#0D0D0D] dark:hover:bg-[#161616] dark:text-[#E5E2DD] dark:border-[#3A3A3A] ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'
);

export const PUNCH_BTN_DANGER = (
  'inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md ' +
  'bg-white hover:bg-red-50 active:bg-red-100 text-red-700 ' +
  'border border-red-300 text-sm font-medium transition-colors ' +
  'dark:bg-[#0D0D0D] dark:hover:bg-red-950/30 dark:text-red-300 dark:border-red-800/60 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'
);

export const PUNCH_BTN_WARN = (
  'inline-flex items-center justify-center gap-2 min-h-[44px] px-4 rounded-md ' +
  'bg-amber-50 hover:bg-amber-100 active:bg-amber-200 text-amber-800 ' +
  'border border-amber-300 text-sm font-medium transition-colors ' +
  'dark:bg-amber-900/20 dark:hover:bg-amber-900/40 dark:text-amber-200 dark:border-amber-700/60 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'
);
